import React from 'react';
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from '@material-tailwind/react';
import { useTranslation } from 'react-i18next';

export const EmploymentExpensesText = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-justify gap-2">
      <div className="font-bold">{t('employmentExpenses.workFromHome')}</div>
      {t('employmentExpenses.text1')}
      <br />
      <div className="ml-2">{t('employmentExpenses.point1')}</div>
      <div className="ml-2">{t('employmentExpenses.point3')}</div>
      <div className="ml-2">{t('employmentExpenses.point4')}</div>
      <div className="ml-2">{t('employmentExpenses.point5')}</div>
      <div className="ml-2">{t('employmentExpenses.point6')}</div>
      <a
        href="https://www.canada.ca/en/revenue-agency/services/forms-publications/forms/t2200.html"
        className="underline text-blue-700"
        target="_blank"
        rel="noreferrer"
      >
        New Updated T2200 Form
      </a>
      <div className="font-bold">{t('employmentExpenses.point2')}</div>
      <div className="">
        {' '}
        <a
          href="https://www.canada.ca/en/revenue-agency/services/tax/individuals/topics/about-your-tax-return/tax-return/completing-a-tax-return/deductions-credits-expenses/line-22900-other-employment-expenses/work-space-home-expenses/calculate-expenses.html"
          className="underline text-blue-700"
          target="_blank"
          rel="noreferrer"
        >
          CRA Work From Home Expenses Calculator
        </a>
      </div>
      <br />
    </div>
  );
};
export const EmploymentMethodText = () => {
  const { t } = useTranslation();

  const [open, setOpen] = React.useState(1);
  const handleOpen = (value) => setOpen(open === value ? 0 : value);
  return (
    <div className="flex flex-col text-justify pt-4 gap-3">
      <Accordion open={open === 1}>
        <AccordionHeader onClick={() => handleOpen(1)}>
          {t('expensesText.detailedMethod')}
        </AccordionHeader>
        <AccordionBody className="flex-col gap-4 text-inherit text-md">
          <div>{t('expensesText.text1')}</div>
          <br />
          <div>{t('expensesText.text2')}</div>
          <br />
          <div className="">{t('expensesText.text3')}</div>
          <br />
          <div className="">{t('expensesText.text4')}</div>
          <br />
          <div className="font-bold">{t('expensesText.text5')}</div>
          <div className="ml-4">{t('expensesText.text6')}</div>
          <div className="ml-4">{t('expensesText.text7')}</div>
          <div className="ml-4">{t('expensesText.text8')}</div>
          <br />
          <div>{t('expensesText.text9')}</div>
          <br />
          <div className="font-bold">{t('expensesText.text10')}</div>
          <div className="ml-4">{t('expensesText.text11')}</div>
          <div className="ml-4">{t('expensesText.text12')}</div>
          <br />
          <div className="font-bold">{t('expensesText.text13')}</div>
          <div className="ml-4">{t('expensesText.text14')}</div>
          <div className="ml-4">{t('expensesText.text15')}</div>
          <div className="ml-4">{t('expensesText.text16')}</div>
          <br />
          <div className="">{t('expensesText.text17')}</div>
          <br />
          <div className="font-bold">{t('expensesText.text18')}</div>
        </AccordionBody>
      </Accordion>
    </div>
  );
};

export const MoveExpenses = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-justify gap-1">
      <hr />
      <div className="mt-2">{t('expensesText.moveExpenses1')}</div>
      <a
        href="https://www.canada.ca/en/revenue-agency/services/forms-publications/forms/t1-m.html"
        className="underline text-blue-700"
        target="_blank"
        rel="noreferrer"
      >
        T1-M Form Link
      </a>
      <div>{t('expensesText.moveExpenses2')}</div>
      <div className="">{t('expensesText.moveExpenses3')}</div>
      <div className="mb-4">{t('expensesText.moveExpenses4')}</div>
    </div>
  );
};
